import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form, Input, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import CrudButtons from "components/button/crudbuttons";
import { 
    Send,
} from "lucide-react";
import {
    getTicketDetails,
    doTicketCreate,
} from "../../../../../../redux/supportticket/supportticketState";
import { DEPARTMENT_ICONS } from "variables/constants";

const MessageTicket = ({
    onCancel,
    getRecord,
    recordData, 
	requesting, 
	success,
    doCreate, 
	doUpdate, 
    ...props
}) => {
    const { recordId, mode } = props;
    const [form] = Form.useForm();

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        getRecord(recordId);
    }, [getRecord, recordId]);

    useEffect(() => {
        if (selectedDepartment && recordData?.categories) {
            const filtered = recordData.categories.filter(
                cat => cat.department_id === selectedDepartment
            );
            setCategoryOptions(filtered);
        } else {
            setCategoryOptions([]);
        }
    }, [selectedDepartment, recordData?.categories]);

    const onSubmit = (formData) => {
        try {
            formData.is_message = 0;

            recordData.tic_id > 0 ? doUpdate(formData): doCreate(formData); 
        } catch (error) {
            console.error('Save failed:', error);
        }
    };

    const priorityLabelMap = {
        Low: "Low - General inquiry",
        Medium: "Medium - Standard request",
        High: "High - Urgent issue",
    };

    const modifiedPriorityOptions = (recordData?.priority || []).map(item => ({
        ...item,
        label: priorityLabelMap[item.label] || item.label,
    }));

    const formatDepartmentOptions = (departments) => {
        if (!departments || !Array.isArray(departments)) return [];
        
        return departments.map(dept => {
            const IconComponent = DEPARTMENT_ICONS[dept.label];
            return {
                value: dept.value,
                label: (
                    <div className="flex items-center gap-2">
                        {IconComponent && <IconComponent className="w-4 h-4 text-slate-600" />}
                        <span>{dept.label}</span>
                    </div>
                ),
            };
        });
    };

    const departmentOptions = formatDepartmentOptions(recordData?.ticDepartment);
    


    return (
        <Card className="p-0">
            <Form
                form={form}
                className={mode !== "view" ? "form" : ""}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div className="space-y-2">
                    <div className="space-y-2">
                        <FormItem
                            label="Department"
                            name="tic_department_id"
                            rules={[requiredField()]}
                        >
                            <Select
                                id="tic_department_id"    
                                placeholder="Select department"
                                options={departmentOptions}
                                showLabel={true}
                                allowClear={true}
                                className="input-field"
                                onChange={(value) => {
                                    setSelectedDepartment(value);
                                    form.setFieldValue('tic_category_id', undefined);
                                }}
                            />
                        </FormItem>
                        <FormItem
                            name="tic_category_id" 
                            label="Category"
                            rules={[requiredField()]}
                        >
                            <Select 
                                id="tic_category_id"
                                allowClear={true}
                                className="input-field"
                                options={categoryOptions}
                                placeholder="Select category"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_priority_id" 
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <Select id="tic_priority_id"
                                allowClear={true}
                                className="input-field"
                                options={modifiedPriorityOptions}
                                placeholder="Select priority"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_title" 
                            label="Subject"
                            rules={[requiredField()]}
                        >
                            <Input id="tic_title"
                                allowClear={true}
                                className="input-field"
                                placeholder="Brief description of your inquiry"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_description"
                            label="Details"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                id="tic_description" 
                                className="input-field"
                                maxLength={255}
                                placeholder="Provide details about your request..."
                                rows={3}
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 justify-end">
                        <CrudButtons
                            mode={mode}
                            recordId={recordData?.tic_id ?? 0}
                            isModal={true}
                            modalId={recordData?.tic_id > 0 ? "edit_ticket" : "add_ticket"}
                            doHideModal={onCancel}
                            cancelLabel="Cancel"
                            submitLabel="Send Message"
                            moduleId={0}
                            cancelIcon=""
                            submitIcon={<Send className="w-4 h-4 mr-2" />}
                            submitClassName="ticket submit-ticket emerald"
                            cancelClassName="ticket cancel-ticket"
                        />
                    </div>
                </div>
            </Form>
        </Card>
    )
};
const mapStateToProps = (state) => ({
    recordData: state.ticket.ticketDetails?.data,
    requesting: state.ticket.ticketDetails?.requesting,
    success: state.ticket.ticketDetails?.succcess,
    departmentList: state.optionlist.departmentList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getTicketDetails(id)),
    doCreate: (data) => dispatch(doTicketCreate(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MessageTicket);